export const PARKING_AVAILABILITY_API = `${process.env.DAP_BASE_URI}/parking/availability/CVG`;
